// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"f9-z"};